export const userInfo = (vis) => (dispatch, getState) => {
    dispatch({
        type: "change1",
        payload: vis
    })
};